<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="row" fxLayoutAlign="center" *ngIf="isUser" class="profile">
  <!-- <img (click)="toProfile()" class='user-pic' [src]='userPic' alt='image'> -->
  <div class="sc-profile-text">{{ username }}</div>
</div>
<div *ngIf="!isUser" class="user" fxLayout="row" fxLayoutAlign="center center">
  <button
    id="loginbutton"
    mat-button
    (click)="toSignIn()"
    class="notranslate"
    i18n
  >
    LOGIN
  </button>
</div>
